module.exports = __webpack_public_path__ + "static/media/cyko-headz.e3ad641f.png";